"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getGroupsBySearchText = void 0;
const tslib_1 = require("tslib");
const groupBy_1 = tslib_1.__importDefault(require("lodash/groupBy"));
const omit_1 = tslib_1.__importDefault(require("lodash/omit"));
const createReport_1 = require("../__common/createReport");
const getElasticsearchQueryFromFilters_1 = require("../__common/elasticsearchQuery/getElasticsearchQueryFromFilters");
const getContentGroupMetrics_1 = require("./common/getContentGroupMetrics");
const getUserGroupMetrics_1 = require("./common/getUserGroupMetrics");
const groupQueryHelper_1 = require("./common/groupQueryHelper");
function getGroupsBySearchText(input) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        const searchText = input.searchText;
        const filters = input.filters;
        const projection = input.ReportProjection;
        let query = getElasticsearchQueryFromFilters_1.getElasticsearchQueryForFilters(filters.groupFilters);
        if (searchText && searchText !== '') {
            const searchTextQuery = {
                match: {
                    name: {
                        query: searchText,
                        fuzziness: 1,
                        max_expansions: 10,
                        prefix_length: 1,
                        boost: 10000
                    }
                }
            };
            if (!query) {
                query = {};
            }
            if (!query.bool) {
                query.bool = {};
            }
            if (!query.bool.must) {
                query.bool.must = [];
            }
            query.bool.must.push(searchTextQuery);
        }
        query = { body: { query } };
        if (projection) {
            query._source = omit_1.default(projection.groupProjection, ['custom']);
        }
        let groups = [];
        if (input.from || input.from === 0) {
            query.from = input.from;
            query.size = input.size ? input.size : 10;
            const elasticsearchResult = yield groupQueryHelper_1.getGroupsUsingQuery(query);
            groups = elasticsearchResult.groups;
        }
        else {
            query.size = 100;
            const elasticsearchResult = yield groupQueryHelper_1.getGroupsUsingQuery(query, '30s');
            const { scrollId, total } = elasticsearchResult;
            // Fetching remaing batch of groups using scroll
            groups = yield groupQueryHelper_1.fetchFromScroll({
                total,
                scrollId,
                groups: elasticsearchResult.groups
            });
        }
        const customProjection = projection && projection.groupProjection && projection.groupProjection.custom;
        if (customProjection && customProjection.indexOf('groupMetrics') >= 0) {
            // Fetching groupMetrics corresponding to matching results
            const { user: userGroups, content: contentGroups } = groupBy_1.default(groups, 'groupType');
            const contentGroupMetrics = yield getContentGroupMetrics_1.getContentGroupMetrics(contentGroups);
            const userGroupMetrics = yield getUserGroupMetrics_1.getUserGroupMetrics(userGroups);
            return createReport_1.createGroupReport({ contentGroupMetrics, groups, total: groups.length, userGroupMetrics });
        }
        return createReport_1.createGroupReport({ contentGroupMetrics: [], groups, total: groups.length, userGroupMetrics: [] });
    });
}
exports.getGroupsBySearchText = getGroupsBySearchText;
//# sourceMappingURL=getGroupsBySearchText.js.map